import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import PollOption from './PollOption';
import localStyles from './PollView.scss';
const PollView = ({ deviation: { poll }, onVote, canVote, className, hideQuestion, draftJsThemeOverride, answerClassName, stylesheet: s = localStyles, optionStylesheet, optionImageSize, optionHoverImageSize })=>{
    const { t } = useTranslation();
    const onClickOption = useCallback((answerId)=>{
        if (!poll) {
            return;
        }
        onVote({
            pollId: poll.pollId,
            userId: poll.user.userId,
            answerId
        });
    }, [
        onVote,
        poll
    ]);
    if (!poll) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            pollid: poll.pollId
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, !hideQuestion && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['question']
    }, poll.question), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['votes']
    }, t('pollView.votes', {
        count: poll.votes
    })))), poll.answers.map((answer)=>/*#__PURE__*/ React.createElement(PollOption, {
            key: answer.answerId,
            className: s['poll-option'],
            answer: answer,
            canVote: canVote,
            onClick: onClickOption,
            draftJsThemeOverride: draftJsThemeOverride,
            answerClassName: answerClassName,
            stylesheet: optionStylesheet,
            imageSize: optionImageSize,
            hoverImageSize: optionHoverImageSize
        }))));
};
PollView.displayName = 'PollView';
export default PollView;
